<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div class="detail-body">
    <div class="detail-documents relevant-info">
        <h2>
            <!-- <span class="material-symbols-outlined hashtag"> tag </span> -->
            {{ 'REQUEST_DETAIL.DOCUMENTS_ANALYZED' | translate }}
        </h2>

        <div class="detail-content">
            <div class="detail-content-header">
                <span class="material-symbols-outlined custom-doc ">description</span>
                <h3>{{ 'REQUEST_DETAIL.ENRICHMENT' | translate }}</h3>

                <div class="accordion-buttons">
                    <!-- EXPAND ALL BUTTON -->
                    <p-button
                        *ngIf="freelancerRequestDetailDocumentsService.enrichmentAccordion.length > 0 && freelancerRequestDetailDocumentsService.activedAccordionItems.length !== freelancerRequestDetailDocumentsService.enrichmentAccordion.length"
                        [disabled]="freelancerRequestDetailDocumentsService.activedAccordionItems.length === freelancerRequestDetailDocumentsService.enrichmentAccordion.length"
                        (click)="freelancerRequestDetailDocumentsService.expandAll()"
                        pTooltip="{{ 'REQUEST_DETAIL.EXPAND_ALL' | translate }}" tooltipPosition="top"
                        styleClass="p-button-rounded p-button-secondary p-button-text"
                    >
                        <span class="material-symbols-outlined"> keyboard_arrow_down </span>
                    </p-button>

                    <!-- COLLAPSE ALL BUTTON -->
                    <p-button
                        *ngIf="freelancerRequestDetailDocumentsService.enrichmentAccordion.length > 0 && freelancerRequestDetailDocumentsService.activedAccordionItems.length !== 0"
                        [disabled]="freelancerRequestDetailDocumentsService.activedAccordionItems.length === 0"
                        (click)="freelancerRequestDetailDocumentsService.colapseAll()"
                        pTooltip="{{ 'REQUEST_DETAIL.COLLAPSE_ALL' | translate }}" tooltipPosition="top"
                        styleClass="p-button-rounded p-button-secondary p-button-text"
                    >
                        <span class="material-symbols-outlined"> keyboard_arrow_up </span>
                    </p-button>
                </div>
            </div>

            <div class="">
                <!-- <p class="detail-item-name">{{ enrichment.title }}</p> -->
                <p-accordion [multiple]="true" [(value)]="freelancerRequestDetailDocumentsService.activedAccordionItems">
                    <p-accordion-panel
                        *ngFor="let enrichment of freelancerRequestDetailDocumentsService.enrichmentAccordion; let i = index"
                        [value]="i"
                        (onOpen)="freelancerRequestDetailDocumentsService.onTabOpen(i)"
                        (onClose)="freelancerRequestDetailDocumentsService.onTabClose(i)"
                    >
                        <p-accordion-header>
                            {{ enrichment.title | translate }}
                        </p-accordion-header>
                        <p-accordion-content>
                        <table>
                            <thead>
                                <th>{{ 'REQUEST_DETAIL.KEY' | translate }}</th>
                                <th>{{ 'REQUEST_DETAIL.VALUE' | translate }}</th>
                            </thead>
                            <tbody>
                                <ng-container *ngFor="let e of enrichment.elements">
                                    @if(feasibilityKeys.includes(e.key)){
                                        <tr>
                                            <td>{{ translateFeasibilityKey(e.key) }}</td>
                                            @if(isNumber(e.value)){
                                                <td class="W200">{{ +e.value | number:'1.0-2':'es-ES' }}</td>
                                            }@else{
                                                <td class="W200">{{ translateIfBoolean(e.value) }}</td>
                                            }
                                        </tr>
                                    }@else{
                                        <tr>
                                            <td>{{ translateEnrichmentKey(e.key) }}</td>
                                            @if(isNumber(e.value)){
                                                <td class="W200">{{ +e.value | number:'1.0-2':'es-ES' }}</td>
                                            }@else {
                                                <td class="W200">{{ e.value }}</td>
                                            }
                                        </tr>
                                    }
                                </ng-container>
                            </tbody>
                        </table>
                        </p-accordion-content>
                    </p-accordion-panel>
                </p-accordion>
            </div>
        </div>

        <div *ngIf="showFesibilityRules()" class="detail-content" style="margin-top: 18px;">
            <div class="detail-content-header">
                <span class="material-symbols-outlined custom-doc "> rule </span>
                <h3>{{ 'ADMINISTRATION.FEASIBILITY_RULES' | translate }}</h3>
            </div>
            <app-feasibility-rules-table [feasibilityRules]="getFeasibilityRules()" />
        </div>

        @if (irpfTableService.isInit()){
            <div  class="detail-content" style="margin-top: 18px;">
                <div class="detail-content-header">
                    <span class="material-symbols-outlined custom-doc "> account_balance </span>
                    <h3>{{ 'IRPF.TITLE' | translate }}</h3>
                </div>
                <app-irpf-table />
            </div>
        }
    </div>

    <div class="detail-documents">
        <h2>
            <!-- <span class="material-symbols-outlined hashtag"> tag </span> -->
            {{ 'REQUEST_DETAIL.REQUEST_RECEIVED_DOCUMENTS' | translate }}
        </h2>
        <div class="detail-content">
            <div class="detail-content-header">
                <span class="material-symbols-outlined custom-doc "> description </span>
                <h3>{{ 'REQUEST_DETAIL.TAX_DOCUMENTATION' | translate }}</h3>
            </div>
            <div class="detail-content-item" *ngFor="let name of freelancerRequestDetailDocumentsService.documentNames">
                @if (freelancerRequestDetailService.showDocumentDetails(name)) {
                    <p class="detail-item-name">{{ 'DOCUMENTS.' + name | translate }}</p>
                    <div class="detail-item-links">
                        <p-button *ngIf="showOpenPDFButton(name)" (click)="openPDF(name)" pTooltip="{{ 'REQUEST_DETAIL.OPEN_PDF' | translate }}" tooltipPosition="top">
                            <span class="material-symbols-outlined"> visibility </span>
                            {{ 'REQUEST_DETAIL.PDF' | translate }}
                        </p-button>
                        <p-button (click)="openJSON(name)" pTooltip="{{ 'REQUEST_DETAIL.OPEN_JSON' | translate }}" tooltipPosition="top">
                            <span class="material-symbols-outlined"> visibility </span>
                            {{ 'REQUEST_DETAIL.JSON' | translate }}
                        </p-button>
                        <p-button (click)="downloadJSON(name)" pTooltip="{{ 'REQUEST_DETAIL.DOWNLOAD_JSON' | translate }}" tooltipPosition="top">
                            <span class="material-symbols-outlined"> download </span>
                            {{ 'REQUEST_DETAIL.JSON' | translate }}
                        </p-button>
                    </div>
                }
            </div>
        </div>
    </div>

    @if(isFeasibilityAvailable()) {
        <div class="detail-history">
            <div (click)="freelancerRequestDetailService.isCalculateViabilitySidebarVisible = true">
                <span class="material-symbols-outlined"> dataset </span>
                <p>{{ "REQUEST_DETAIL.CALCULATE_FEASIBILITY" | translate }}</p>
            </div>
        </div>
    }
</div>
